<template>
<div class="animated fadeIn">
  <Callout variant="warning" class="m-0 py-3">
    <div>: {{historyData.formData.campaignTitle}}</div>
    <div>: {{historyData.formData.simulationTitle}}</div>
    <small class="text-muted mr-3"><i class="icon-calendar"></i>&nbsp;{{historyData.std_dt}}</small>
  </Callout>
  <hr class="mx-3 my-0">
</div>
</template>

<script>
import Callout from './Callout'
export default {
  components: {
    Callout,
  },
  props: {
    historyData:null
  },
  mounted:function(){

  },
  methods:{

  }
}
</script>



// WEBPACK FOOTER //
// src/components/history.vue